import { useMemo, useRef } from 'react';

export function useSettleCallbackOnce({
  onSave,
  onCancel,
}: {
  onSave: () => void;
  onCancel: () => void;
}): { onSave: () => void; onCancel: () => void } {
  const settledRef = useRef(false);

  return useMemo(
    () => ({
      onSave: () => {
        if (settledRef.current) {
          return;
        }

        settledRef.current = true;
        onSave();
      },
      onCancel: () => {
        if (settledRef.current) {
          return;
        }

        settledRef.current = true;
        onCancel();
      },
    }),
    [onSave, onCancel],
  );
}
